/**
 * Утилиты для управления мета-тегами Open Graph и Twitter Card
 */

/**
 * Обновляет мета-теги для превью в соцсетях
 * @param imageUrl - URL изображения сертификата
 * @param title - Заголовок (по умолчанию "STONfi DeFi Certificate")
 * @param description - Описание (по умолчанию "Я завершил курс DeFi на STONfi! Получил сертификат 🎓")
 */
export function updateMetaTags(
  imageUrl: string,
  title: string = 'STON.fi DeFi Certificate',
  description: string = '🎓 I completed the DeFi course on STON.fi and got my certificate!'
): void {
  const baseUrl = window.location.origin + window.location.pathname;
  // Используем query параметр вместо хеша для лучшей поддержки Twitter Card
  const pageUrl = `${baseUrl}?certificate=${encodeURIComponent(imageUrl)}`;

  // Функция для создания или обновления мета-тега
  const setMetaTag = (property: string, content: string, isProperty = true) => {
    const selector = isProperty
      ? `meta[property="${property}"]`
      : `meta[name="${property}"]`;
    let meta = document.querySelector(selector) as HTMLMetaElement;

    if (!meta) {
      meta = document.createElement('meta');
      if (isProperty) {
        meta.setAttribute('property', property);
      } else {
        meta.setAttribute('name', property);
      }
      document.head.appendChild(meta);
    }

    meta.setAttribute('content', content);
  };

  // Open Graph мета-теги
  setMetaTag('og:title', title);
  setMetaTag('og:description', description);
  setMetaTag('og:image', imageUrl);
  setMetaTag('og:image:width', '1200');
  setMetaTag('og:image:height', '630');
  setMetaTag('og:image:type', 'image/png');
  setMetaTag('og:url', pageUrl);
  setMetaTag('og:type', 'website');

  // Twitter Card мета-теги
  setMetaTag('twitter:card', 'summary_large_image', false);
  setMetaTag('twitter:title', title, false);
  setMetaTag('twitter:description', description, false);
  setMetaTag('twitter:image', imageUrl, false);
  setMetaTag('twitter:image:alt', 'STONfi DeFi Certificate', false);

  // Обновляем title страницы
  document.title = title;
}

/**
 * Восстанавливает стандартные мета-теги
 */
export function resetMetaTags(): void {
  const defaultTitle = 'STONfi.pools';
  document.title = defaultTitle;

  // Удаляем все кастомные мета-теги
  const metaTagsToRemove = [
    'meta[property="og:title"]',
    'meta[property="og:description"]',
    'meta[property="og:image"]',
    'meta[property="og:image:width"]',
    'meta[property="og:image:height"]',
    'meta[property="og:image:type"]',
    'meta[property="og:url"]',
    'meta[property="og:type"]',
    'meta[name="twitter:card"]',
    'meta[name="twitter:title"]',
    'meta[name="twitter:description"]',
    'meta[name="twitter:image"]',
    'meta[name="twitter:image:alt"]',
  ];

  metaTagsToRemove.forEach((selector) => {
    const meta = document.querySelector(selector);
    if (meta) {
      meta.remove();
    }
  });
}

/**
 * Инициализирует мета-теги при загрузке страницы на основе query параметра или хеша
 */
export function initMetaTagsFromHash(): void {
  // Проверяем query параметр
  const urlParams = new URLSearchParams(window.location.search);
  const certificateUrl = urlParams.get('certificate');

  if (certificateUrl) {
    updateMetaTags(decodeURIComponent(certificateUrl));
    return;
  }

  // Fallback на хеш для обратной совместимости
  const hash = window.location.hash;
  const match = hash.match(/certificate=(.+)/);

  if (match) {
    const imageUrl = decodeURIComponent(match[1]);
    updateMetaTags(imageUrl);
  }
}
